/* eslint-disable */
export default {
  noActiveCalls: '활성 통화 없음',
  noCalls: '검색 결과가 없습니다.',
  currentCall: '현재 통화',
  ringCall: '연결 중인 통화',
  onHoldCall: '대기 중인 통화',
  historyCalls: '이전 통화',
  otherDeviceCall: '다른 디바이스에서 진행 중인 통화',
  searchPlaceholder: '검색...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
